export const menuWidth = (showMenu, collapsed) => showMenu ? collapsed ? '60px' : '200px' : '0px'

export const textError = '#F44336'
export const textWarning = '#FF883F'
export const textGray = '#888888'

export const borderGray = '#CCCCCC'
export const btnGray = '#647D91'
export const bgSoftGray = '#EAEFF5'

// Status Tag
export const tagDraft      = 'linear-gradient(255deg, #808080, #A8A8A8)'
export const tagNew        = 'linear-gradient(255deg, #5280ff, #0057ff)'
export const tagInProgress = 'linear-gradient(213deg, #fc6180, #fa548c)'
export const tagRevise     = 'linear-gradient(255deg, #FF883F, #FE9E5F)'
export const tagCompleted  = 'linear-gradient(252deg, #32da8b, #28c47b)'
export const tagCanceled   = 'linear-gradient(255deg, #ff523f, #fe6f5f)'
export const tagReject     = 'linear-gradient(255deg, #ff1900, #ff4833)'
export const tagApproved   = 'linear-gradient(255deg, #9356fc, #674fff)'
export const tagWait   = 'linear-gradient(255deg, #00CCFF, #00CCFF)'
export const tagVendorSigned   = 'linear-gradient(255deg, #6C2E9A, #6C2E9A)'

export const tagColors = [ 
  tagDraft, // 0
  tagNew, // 1
  tagInProgress, // 2
  tagRevise, // 3
  tagCompleted, // 4
  tagReject, // 5
  tagCanceled, // 6
  tagApproved, // 7
  tagApproved, // 8 Accepted
  tagWait, // 9 contract status
  tagVendorSigned, // 10 contract status,
  tagApproved, // 11 unused
  tagApproved, // 12 unused
  tagApproved, // 13 PO Accepted Upload Stamp Duty 
  tagApproved, // 14 PO Accepted Review Stamp Duty 
  tagNew, // 15 Code of Conduct Wait to Acknowledge
  tagCompleted, // 15 Code of Conduct Acknowledged
  tagCanceled, // 15 Code of Conduct Excepted
]